/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccountManagerRegisterResponse } from './AccountManagerRegisterResponse';

export type AccountManagerRegisterResponseApiRespoonse = {
    data?: AccountManagerRegisterResponse;
    status?: AccountManagerRegisterResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AccountManagerRegisterResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

